export default __webpack_public_path__ + "static/media/pop-up-cross.86267f49.svg";